import { useNavigate, useParams } from "react-router-dom";
import { monthFormat } from "./month-format";

export function MonthDropDown({ months }) {
    const navigate = useNavigate();
    const { month } = useParams();
    return (
        <select
            value={month}
            onChange={(event) => {
                event.preventDefault();
                navigate(`../${event.target.value}`);
            }}
        >
            {months.map((m) => (
                <option key={m} value={m.substring(0, 10)}>
                    {monthFormat(new Date(m))}
                </option>
            ))}
        </select>
    );
}
